"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Endpoints = void 0;
exports.setAxiosInstance = setAxiosInstance;
exports.parseParam = parseParam;
exports.generateAxios = generateAxios;
let axiosInstance;
function setAxiosInstance(instance) {
    axiosInstance = instance;
}
function parseParam(endpoint, params) {
    let resolved = endpoint.path;
    for (const [key, value] of Object.entries(params)) {
        resolved = resolved.replace(`:${key}`, encodeURIComponent(String(value)));
    }
    return resolved;
}
function parseQuery(query) {
    const parsed = {};
    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null)
            continue;
        if (Array.isArray(value)) {
            parsed[key] = value.length > 0 && typeof value[0] === 'object' ? JSON.stringify(value) : value.join(',');
        }
        else if (typeof value === 'object') {
            parsed[key] = JSON.stringify(value);
        }
        else {
            parsed[key] = value;
        }
    }
    return parsed;
}
function generateAxios(endpoint, payload, options = {}) {
    return axiosInstance({
        url: payload.params ? parseParam(endpoint, payload.params) : endpoint.path,
        method: endpoint.method,
        ...(payload.query && { params: parseQuery(payload.query) }),
        ...(payload.body !== undefined && { data: payload.body }),
        ...options,
    });
}
exports.Endpoints = {
    auth: {
        user: {
            login: { path: '/auth/login', method: 'POST' },
            logout: { path: '/auth/logout', method: 'POST' },
            loginOtp: { path: '/auth/login/otp', method: 'POST' },
            renew: { path: '/auth/renew', method: 'POST' },
        },
        admin: {
            login: { path: '/admin/auth/login', method: 'POST' },
            renew: { path: '/admin/auth/renew', method: 'POST' },
            logout: { path: '/admin/auth/logout', method: 'POST' },
        },
    },
    users: {
        user: {
            query: { path: '/users/query', method: 'GET' },
            profileImage: { path: '/users/profile-image', method: 'POST' },
            update: { path: '/users/', method: 'PATCH' },
            me: { path: '/users/me', method: 'GET' },
        },
        admin: {
            create: { path: '/admin/users/', method: 'POST' },
            update: { path: '/admin/users/:id', method: 'PATCH' },
            query: { path: '/admin/users/query', method: 'GET' },
            profileImage: { path: '/admin/users/:id/profile-image', method: 'POST' },
        },
    },
    visits: {
        user: {
            query: { path: '/visits/query', method: 'GET' },
            initiateVisit: { path: '/visits/initiate-visit', method: 'POST' },
            accept: { path: '/visits/:id/accept', method: 'POST' },
            end: { path: '/visits/:id/end', method: 'POST' },
            preview: { path: '/visits/preview', method: 'GET' },
        },
        admin: {
            query: { path: '/admin/visits/query', method: 'GET' },
            refund: { path: '/admin/visits/:id/refund', method: 'PATCH' },
            end: { path: '/admin/visits/:id/end', method: 'PATCH' },
        },
    },
    transactions: {
        user: {
            query: { path: '/transactions/', method: 'GET' },
        },
        admin: {
            create: { path: '/admin/transactions/:id', method: 'POST' },
            query: { path: '/admin/transactions/query', method: 'GET' },
            settle: { path: '/admin/transactions/settle', method: 'POST' },
        },
    },
    surveys: {
        user: {
            submit: { path: '/surveys/:id', method: 'POST' },
            cancel: { path: '/surveys/:id/cancel', method: 'PATCH' },
        },
        admin: {
            query: { path: '/admin/surveys/query', method: 'GET' },
        },
    },
    gateway: {
        user: {
            token: { path: '/user/gateway/token', method: 'GET' },
        },
        callback: { path: '/gateway/cb', method: 'GET' },
        admin: {
            verifyTransactions: { path: '/admin/gateways/verify-transactions', method: 'GET' },
        },
    },
    files: {
        user: {
            download: { path: '/files/:id', method: 'GET' },
        },
    },
    specializations: {
        user: {
            query: { path: '/specializations/query', method: 'GET' },
        },
        admin: {
            create: { path: '/admin/specializations/', method: 'POST' },
            update: { path: '/admin/specializations/:id', method: 'PATCH' },
            delete: { path: '/admin/specializations/', method: 'DELETE' },
            query: { path: '/admin/specializations/query', method: 'GET' },
        },
    },
    healthFacilities: {
        user: {
            query: { path: '/health-facilities/query', method: 'GET' },
        },
        admin: {
            create: { path: '/admin/health-facilities/', method: 'POST' },
            update: { path: '/admin/health-facilities/:id', method: 'PATCH' },
            delete: { path: '/admin/health-facilities/:id', method: 'DELETE' },
            query: { path: '/admin/health-facilities/query', method: 'GET' },
            logoImage: { path: '/admin/health-facilities/:id/logo-image', method: 'PATCH' },
            wallpaperImage: { path: '/admin/health-facilities/:id/wallpaper-image', method: 'PATCH' },
        },
    },
    discounts: {
        user: {
            verify: { path: '/discounts', method: 'GET' },
        },
        admin: {
            create: { path: '/admin/discounts/', method: 'POST' },
            update: { path: '/admin/discounts/:id', method: 'PATCH' },
            delete: { path: '/admin/discounts/', method: 'DELETE' },
            query: { path: '/admin/discounts/query', method: 'GET' },
        },
    },
    notifications: {
        user: {},
        admin: {
            create: { path: '/admin/notifications/', method: 'POST' },
            sms: { path: '/admin/notifications/sms', method: 'POST' },
            query: { path: '/admin/notifications/query', method: 'GET' },
        },
    },
    serverConfigs: {
        user: {
            tac: { path: '/server-configs/tac', method: 'GET' },
        },
        admin: {
            update: { path: '/admin/server-configs/', method: 'PATCH' },
            get: { path: '/admin/server-configs/', method: 'GET' },
            createBanner: { path: '/admin/server-configs/banner', method: 'POST' },
            updateBanner: { path: '/admin/server-configs/banner/:id', method: 'PATCH' },
            deleteBanner: { path: '/admin/server-configs/banner/:id', method: 'DELETE' },
        },
    },
    admins: {
        admin: {
            create: { path: '/admin/admins/', method: 'POST' },
            update: { path: '/admin/admins/:id', method: 'PATCH' },
            query: { path: '/admin/admins/query', method: 'GET' },
            me: { path: '/admin/admins/me', method: 'GET' },
        },
    },
    conferences: {
        admin: {
            query: { path: '/admin/conferences/query', method: 'GET' },
        },
    },
    chats: {
        user: {
            uploadChatFile: { path: '/chats/file', method: 'POST' },
            history: { path: '/chats/history', method: 'GET' },
        },
    },
    receipts: {
        admin: {
            audit: { path: '/receipts/audit', method: 'GET' },
        },
    },
    clusterMetrics: {
        admin: {
            query: { path: '/admin/cluster-metrics/query', method: 'GET' },
        },
    },
    clientErrors: {
        admin: {
            query: { path: '/admin/client-errors', method: 'GET' },
            acknowledge: { path: '/admin/client-errors/:id/acknowledge', method: 'PATCH' },
            deleteAll: { path: '/admin/client-errors', method: 'DELETE' },
            fetchSource: { path: '/admin/client-errors/fetch-source', method: 'GET' },
        },
    },
};
